// extracted by mini-css-extract-plugin
module.exports = {"tabTitle":"TabComponent_tabTitle__UQY5a","container":"TabComponent_container__1RN_3"};